export default __webpack_public_path__ + "static/media/logo-white.9b86b89f.png";